module.exports = __webpack_public_path__ + "static/img/cost01.91e6ccdf.png";